const EXPLORER_BASE = (
  process.env.REACT_APP_BSC_MAINNET_EXPLORER || "https://bscscan.com/"
).replace(/\/?$/, "/");

export const bscScanTxUrl = (hash: string) => `${EXPLORER_BASE}tx/${hash}`;

export const bscScanAddressUrl = (address: string) =>
  `${EXPLORER_BASE}address/${address}`;

export const shortenHash = (value: string, head = 6, tail = 4) => {
  if (!value) return "";
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
};
